'use client';
import React from 'react';

export const AdvancedLoginIllustration: React.FC = () => (
  <svg
      width='600'
      height='450'
      viewBox='0 0 480 360'
      xmlns='http://www.w3.org/2000/svg'
      style={{ width: '100%', height: '100%' }}
  >
    <defs>
      { /* Background gradient */ }
      <linearGradient id='bg-gradient' x1='0%' y1='0%' x2='100%' y2='100%'>
        <stop offset='0%' stopColor='#2AEA40' />
        <stop offset='100%' stopColor='#093725' />
      </linearGradient>
      { /* Drop-shadow filter */ }
      <filter id='shadow' x='-50%' y='-50%' width='200%' height='200%'>
        <feDropShadow
            dx='0'
            dy='4'
            stdDeviation='4'
            floodColor='#000'
            floodOpacity='0.2'
        />
      </filter>
    </defs>

    <style>{ `
      /* Network nodes pulse */
      .node {
        animation: pulseNode 3s ease-in-out infinite;
        transform-box: fill-box;
        transform-origin: center;
      }
      @keyframes pulseNode {
        0%,100% { r:6; opacity:1; }
        50%    { r:9; opacity:0.6; }
      }

      /* Dashed connector lines move */
      .node-line {
        stroke-dasharray:4 4;
        animation: dash 6s linear infinite;
      }
      @keyframes dash {
        to { stroke-dashoffset:16; }
      }

      /* Float the whole laptop */
      .laptop {
        animation: float 5s ease-in-out infinite;
      }
      @keyframes float {
        0%,100% { transform: translateY(0); }
        50%     { transform: translateY(-10px); }
      }

      /* Lock “unlock” animation */
      .lock {
        animation: lockOpen 8s ease-in-out infinite;
        /* pivot at the base of shackle: x=240, y=155 */
        transform-origin: 240px 155px;
      }
      @keyframes lockOpen {
        0%,40%   { transform: rotate(0deg); }
        45%,55%  { transform: rotate(-45deg); } /* open */
        60%,100% { transform: rotate(0deg); }    /* close */
      }

      /* Scanning bar across screen */
      .scanner {
        fill: #2AEA40;
        opacity: 0.2;
        animation: scan 4s linear infinite;
      }
      @keyframes scan {
        0%   { y:150; }
        50%  { y:160; }
        100% { y:150; }
      }
    ` }</style>

    { /* Full background */ }
    <rect width='100%' height='100%' fill='url(#bg-gradient)' rx='16' />

    { /* Animated network behind */ }
    <g>
      { [
        [100, 100],
        [380, 80],
        [100, 300],
        [380, 300],
        [240, 50],
        [240, 310],
      ].map(([cx, cy], i) => (
        <React.Fragment key={i}>
          <line
              x1='240'
              y1='170'
              x2={cx}
              y2={cy}
              className='node-line'
              stroke='#FFF'
              strokeWidth='1'
              opacity='0.4'
          />
          <circle className='node' cx={cx} cy={cy} r='6' fill='#FFF' />
        </React.Fragment>
      )) }
    </g>

    { /* Laptop + lock group */ }
    <g className='laptop'>
      { /* Laptop screen */ }
      <rect
          x='120'
          y='100'
          width='240'
          height='140'
          rx='8'
          fill='#FFF'
          filter='url(#shadow)'
      />
      { /* Keyboard area */ }
      <rect x='120' y='250' width='240' height='16' rx='4' fill='#E5E7EB' />

      { /* Scanning bar */ }
      <rect x='120' width='240' height='10' className='scanner' />

      { /* Padlock on screen (scaled up 1.2×) */ }
      <g
          className='lock'
          transform='translate(240 180) scale(1.2) translate(-240 -180)'
      >
        { /* Shackle */ }
        <path
            d='M220,155 a20,20 0 0 1 40,0'
            fill='none'
            stroke='#093725'
            strokeWidth='6'
        />
        { /* Body */ }
        <rect
            x='220'
            y='155'
            width='40'
            height='50'
            rx='6'
            fill='#FFF'
            stroke='#093725'
            strokeWidth='4'
        />
        { /* Keyhole */ }
        <circle cx='240' cy='180' r='6' fill='#093725' />
        <rect x='236' y='186' width='8' height='14' rx='2' fill='#093725' />
      </g>
    </g>
  </svg>
);
